export default "__VITE_ASSET__6b8e9271__"